import { render, staticRenderFns } from "./InterProcessConfigurationDetails.vue?vue&type=template&id=00f05bcc&"
import script from "./InterProcessConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./InterProcessConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00f05bcc')) {
      api.createRecord('00f05bcc', component.options)
    } else {
      api.reload('00f05bcc', component.options)
    }
    module.hot.accept("./InterProcessConfigurationDetails.vue?vue&type=template&id=00f05bcc&", function () {
      api.rerender('00f05bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/InterProcessConfigurationDetails.vue"
export default component.exports